import { AccountTabScreenBoundary } from '@/src/components/navigation/AccountTabScreenBoundary'
import SettingsScreen from '@/src/features/settings/screens/SettingsScreen'

export default function SettingsTab() {
  return (
    <AccountTabScreenBoundary>
      <SettingsScreen />
    </AccountTabScreenBoundary>
  )
}
